export default __webpack_public_path__ + "static/media/TheRecharge_Neoncar00435.f977025d.png";